import React from 'react'

import style from './SectionHeader.module.css'

type PropsType = {
  title: string
}

export const SectionHeader = ({ title }: PropsType) => {
  return (
    <div className={style.header}>
      <h2 className="section-title">{title}</h2>
    </div>
  )
}
